import { AtToastPlugin } from '@packages/aliftech-ui';
import { extractErrorMessage } from './utils';

const useToastErrorImperative = () => {
  return async (error, { duration = 4000 } = {}) => {
    AtToastPlugin.error({
      title: await extractErrorMessage(error),
      duration,
    });
  };
};

export default useToastErrorImperative;
